import React, { useState, useLayoutEffect, useEffect } from "react";

/** Components */
import {
  Button,
  TablePagination,
  Paper,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableFooter,
  Collapse,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogActions,
  Tooltip,
  DialogTitle,
} from "@mui/material";

import LoadingProgress from "../../commons/LoadingProgress.component";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import { FilterBy } from "../../commons/filter.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";

/** Api && Function */
import { getGrpSparepart, getSparepart, createSparepart, updateSparepart, deleteSparepart } from "./../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import moment from "moment";
import { useTranslation } from "react-i18next";

/** Hook */
import { useParamFilter } from "../../commons/customHook";
import { useDispatch } from "react-redux";

const initialFilter = {
  group_sparepart: null,
  group_sparepart_id: null,
};

const tblHeader = ["ID", "Tên thiết bị", "Mã thiết bị", "PartNumber", "Số lượng nhập", "Erp Id", "Mã Erp", "Nhóm thiết bị", "Ngày cập nhật", "Trạng thái"];

export default function Sparepart() {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const [isSearchOpen, setSearchOpen] = useState(true);
  const [isDlgOpen, setDlgOpen] = useState(false);
  // custom hook

  const { fetchData, data, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter({ page: 1, per_page: 50 }, getSparepart);

  const [selectedItem, setSelectedItem] = useState(null);
  const [filter, setFilter] = useState({ ...initialFilter });

  const handleSaveResponse = () => {
    fetchData({ group_sparepart_id: filter.grp_sparepart_id });
  };

  /** Set Header Title */
  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN SPAREPART"));
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Tooltip title="Tạo mới">
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                setSelectedItem(null);
                setDlgOpen(true);
              }}
            >
              <AddIcon />
            </Button>
          </Tooltip>
          <Tooltip title="Tạo mới">
            <Button onClick={() => setSearchOpen((prev) => !prev)} variant="outlined">
              <SearchIcon />
            </Button>
          </Tooltip>
        </ButtonGroup>
      </div>
      <div>
        <Collapse in={isSearchOpen} sx={{ marginBottom: "20px" }} align="left">
          <FilterBy
            label={t("Nhóm thiết bị")}
            value={filter.grp_sparepart}
            onChange={(e, newValue) => setFilter((prev) => ({ ...prev, grp_sparepart: newValue, grp_sparepart_id: newValue ? newValue.id : null }))}
            getDataFunc={() => getGrpSparepart({ status: 1 })}
            setDefaultFunc={(option) => setFilter((prev) => ({ ...prev, grp_sparepart: option.find((item) => item.id === filter.grp_sparepart_id) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.grp_sparepart_id]}
            sx={{ display: "inline-flex", width: 250, margin: "5px" }}
          />
          <Button variant="outlined" onClick={handleSaveResponse} style={{ margin: "10px 0" }}>
            {t("Tìm kiếm")}
          </Button>
        </Collapse>
        <div style={{ display: "flex" }}>
          {loading ? (
            <LoadingProgress />
          ) : (
            <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
              <Table stickyHeader>
                <TableHead style={{ backgroundColor: "#f0f3f5" }}>
                  <TableRow>
                    {tblHeader.map((item, id) => (
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="center" key={id}>
                        {item}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.length ? (
                    data.map((item, index) => (
                      <TableRow
                        key={index}
                        onClick={() => {
                          setSelectedItem(item);
                          setDlgOpen(true);
                        }}
                        hover
                        style={{ cursor: "pointer" }}
                      >
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.id}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                          {item.name}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                          {item.code}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                          {item.partnumber}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="right">
                          {item.quantity}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.erp_id}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                          {item.erp_code}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                          {item.group_sparepart_code}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.updated_at && moment(item.updated_at).format("DD/MM/YYYY HH:mm:ss")}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {t(item.status)}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={20}>
                        {t(isAllow ? "Không có dữ liệu" : "No permission")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )}
        </div>
      </div>
      <AddOrEdit data={selectedItem} onClose={() => setDlgOpen(false)} open={isDlgOpen} onResponse={handleSaveResponse} />
    </div>
  );
}
const AddOrEdit = ({ data, onClose, open, onResponse }) => {
  const [input, setInput] = useState({
    name: null,
    code: null,
    partnumber: null,
    specs: null,
    // file: null,
    quantity: 1,
    group_sparepart: null,
    group_sparepart_id: null,
    note: null,
  });
  useLayoutEffect(() => {
    if (data)
      setInput({
        name: data.name,
        code: data.code,
        partnumber: data.partnumber,
        specs: data.specs,
        quantity: data.quantity,
        group_sparepart_id: data.group_sparepart_id,
        exp_date: moment(data.exp_date).format("YYYY-MM-DD"),
        note: data.note,
      });
  }, [data]);
  const handleSave = () => {
    if (data) return updateSparepart(data.id, { ...input, group_sparepart_code: input.group_sparepart?.code, group_sparepart: null });
    else return createSparepart({ ...input, group_sparepart_code: input.group_sparepart?.code, group_sparepart: null });
  };
  const handleDelete = () => {
    return deleteSparepart(data.id);
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" style={{ wordWrap: "break-word" }}>
      <DialogTitle>{data ? "CHỈNH SỬA THÔNG TIN" : "TẠO MỚI THIẾT BỊ (SPAREPART)"}</DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <FilterBy
          label={"Nhóm thiết bị"}
          fullWidth
          value={input.group_sparepart}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, group_sparepart: newValue, group_sparepart_id: newValue ? newValue.id : null }))}
          getDataFunc={() => getGrpSparepart({ status: 1 })}
          setDefaultFunc={(option) => setInput((prev) => ({ ...prev, group_sparepart: option.find((item) => item.id === input.group_sparepart_id) }))}
          triggerSetDefaultFunc={true}
          setDefaultDependencies={[input.group_sparepart_id]}
          sx={{ display: "inline-flex", margin: "5px 0" }}
        />
        <TextField
          InputLabelProps={{ shrink: true }}
          fullWidth
          label={"Tên thiết bị"}
          value={input?.name || ""}
          style={{ margin: "10px 0" }}
          onChange={(e) => setInput((prev) => ({ ...prev, name: e.target.value }))}
        />
        <TextField
          InputLabelProps={{ shrink: true }}
          fullWidth
          label={"Mã thiết bị"}
          value={input?.code || ""}
          style={{ margin: "5px 0" }}
          onChange={(e) => setInput((prev) => ({ ...prev, code: e.target.value }))}
        />
        <TextField
          InputLabelProps={{ shrink: true }}
          fullWidth
          label={"PartNumber"}
          value={input?.partnumber || ""}
          style={{ margin: "5px 0" }}
          onChange={(e) => setInput((prev) => ({ ...prev, partnumber: e.target.value }))}
        />
        <TextField
          InputLabelProps={{ shrink: true }}
          fullWidth
          label={"Số lượng nhập"}
          value={input?.quantity || 1}
          style={{ margin: "5px 0" }}
          onChange={(e) => setInput((prev) => ({ ...prev, quantity: e.target.value }))}
        />
        <CustomDatePicker label={"Ngày hết hạn"} value={input.exp_date} onChange={(value) => setInput((prev) => ({ ...prev, exp_date: value }))} sx={{ margin: "5px 0", width: "100%" }} />
        <TextField
          InputLabelProps={{ shrink: true }}
          fullWidth
          label={"Yêu cầu kỹ thuật"}
          multiline
          maxRows={4}
          value={input?.specs || ""}
          style={{ margin: "5px 0" }}
          onChange={(e) => setInput((prev) => ({ ...prev, specs: e.target.value }))}
        />
        <TextField
          InputLabelProps={{ shrink: true }}
          fullWidth
          label={"Ghi chú"}
          value={input?.note || ""}
          style={{ margin: "5px 0" }}
          onChange={(e) => setInput((prev) => ({ ...prev, note: e.target.value }))}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="secondary">
          {"Hủy"}
        </Button>
        {data && data.status !== "DELETED" && (
          <>
            <ButtonWithAPICall variant="contained" color="error" api={handleDelete} response={onResponse}>
              {"Xoá"}
            </ButtonWithAPICall>
            <ButtonWithAPICall variant="contained" api={handleSave} response={onResponse}>
              {"Chỉnh sửa"}
            </ButtonWithAPICall>
          </>
        )}
        {!data && (
          <ButtonWithAPICall variant="contained" api={handleSave} response={onResponse}>
            {"Tạo mới"}
          </ButtonWithAPICall>
        )}
      </DialogActions>
    </Dialog>
  );
};
